var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { provideIntlService } from '@progress/kendo-vue-intl';
import { getTemplate, noop, getNestedValue, Keys } from '@progress/kendo-vue-common';
import { KEYBOARD_NAV_DATA_ID, KEYBOARD_NAV_DATA_LEVEL } from '@progress/kendo-vue-data-tools';
/**
 * @hidden
 */
var TreeListCellVue2 = {
  name: 'TreeListCell',
  // @ts-ignore
  emits: {
    cellclick: null,
    cellkeydown: null,
    expandchange: null
  },
  props: {
    id: String,
    field: String,
    dataItem: Object,
    format: String,
    colSpan: Number,
    colIndex: Number,
    level: Array,
    expanded: Boolean,
    expandable: Boolean,
    hasChildren: Boolean,
    isSelected: Boolean,
    ariaColumnIndex: Number,
    render: [String, Function, Object]
  },
  inject: {
    kendoIntlService: {
      default: null
    },
    getKeyboardNavigationAttributes: {
      default: noop
    }
  },
  methods: {
    onKeyDownHandler: function onKeyDownHandler(event) {
      var _a = this.$props,
        expandable = _a.expandable,
        dataItem = _a.dataItem,
        level = _a.level;
      if (event.defaultPrevented) {
        return;
      }
      if (event.keyCode === Keys.enter && expandable) {
        event.preventDefault();
        this.$emit('expandchange', event, dataItem, level);
      }
    },
    triggerClick: function triggerClick(e) {
      this.$emit('cellclick', {
        event: e,
        dataItem: this.$props.dataItem,
        field: this.$props.field
      });
    },
    triggerKeydown: function triggerKeydown(e) {
      this.$emit('cellkeydown', {
        event: e,
        dataItem: this.$props.dataItem,
        field: this.$props.field
      });
    },
    triggerEdit: function triggerEdit(dataItem) {
      this.$emit('edit', dataItem);
    },
    triggerAdd: function triggerAdd(dataItem) {
      this.$emit('add', dataItem);
    },
    triggerCancel: function triggerCancel(dataItem) {
      this.$emit('cancel', dataItem);
    },
    triggerSave: function triggerSave(dataItem) {
      this.$emit('save', dataItem);
    },
    triggerRemove: function triggerRemove(dataItem) {
      this.$emit('remove', dataItem);
    },
    triggerExpandChange: function triggerExpandChange(event) {
      var _a = this.$props,
        dataItem = _a.dataItem,
        level = _a.level;
      this.$emit('expandchange', event, dataItem, level);
    }
  },
  computed: {
    wrapperClass: function wrapperClass() {
      var _a;
      var _b = this.$props,
        expandable = _b.expandable,
        isSelected = _b.isSelected;
      return _a = {}, _a['k-text-nowrap'] = expandable, _a['k-selected'] = isSelected, _a;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      hasChildren = _a.hasChildren,
      _b = _a.level,
      level = _b === void 0 ? [0] : _b,
      expanded = _a.expanded,
      dataItem = _a.dataItem,
      format = _a.format,
      id = _a.id,
      colSpan = _a.colSpan,
      ariaColumnIndex = _a.ariaColumnIndex,
      isSelected = _a.isSelected,
      expandable = _a.expandable,
      field = _a.field;
    var data = field ? getNestedValue(field, dataItem) : undefined;
    var navAttrs = this.getKeyboardNavigationAttributes(this.$props.id);
    var intl = provideIntlService(this);
    var dataAsString = '';
    if (data !== undefined && data !== null) {
      dataAsString = format ? intl.format(format, data) : data.toString();
    }
    var icons = [];
    if (expandable) {
      icons.push.apply(icons, level.slice(1).map(function (_x) {
        return h("span", {
          "class": "k-icon k-i-none"
        });
      }, this));
      if (hasChildren) {
        icons.push(h("span", {
          "class": "k-icon k-i-".concat(expanded ? 'caret-alt-down' : 'caret-alt-right'),
          key: "expand-collapse",
          onClick: this.triggerExpandChange,
          on: this.v3 ? undefined : {
            "click": this.triggerExpandChange
          },
          "data-prevent-selection": true,
          attrs: this.v3 ? undefined : {
            "data-prevent-selection": true
          }
        }));
      } else {
        icons.push(h("span", {
          "class": "k-icon k-i-none",
          key: icons.length
        }));
      }
    }
    var defaultRendering = h("td", {
      "class": this.wrapperClass,
      colSpan: colSpan,
      attrs: this.v3 ? undefined : {
        colSpan: colSpan,
        "aria-colindex": ariaColumnIndex,
        "aria-expanded": hasChildren ? expanded : undefined,
        "aria-selected": isSelected,
        role: 'gridcell',
        "data-grid-col-index": this.$props.colIndex,
        tabindex: navAttrs.tabIndex,
        "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
        "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
      },
      "aria-colindex": ariaColumnIndex,
      "aria-expanded": hasChildren ? expanded : undefined,
      "aria-selected": isSelected,
      role: 'gridcell',
      onClick: this.triggerClick,
      on: this.v3 ? undefined : {
        "click": this.triggerClick,
        "keydown": this.onKeyDownHandler
      },
      onKeydown: this.onKeyDownHandler,
      "data-grid-col-index": this.$props.colIndex,
      tabindex: navAttrs.tabIndex,
      "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
      "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
    }, [icons, dataAsString]);
    return getTemplate.call(this, {
      h: h,
      template: this.$props.render,
      defaultRendering: defaultRendering,
      additionalProps: __assign(__assign({}, this.$props), {
        value: data
      }),
      additionalListeners: {
        click: this.triggerClick,
        keydown: this.triggerKeydown,
        edit: this.triggerEdit,
        add: this.triggerAdd,
        cancel: this.triggerCancel,
        save: this.triggerSave,
        remove: this.triggerRemove
      }
    });
  }
};
/**
 * @hidden
 */
var TreeListCell = TreeListCellVue2;
export { TreeListCell, TreeListCellVue2 };